import React from 'react'
import { Button, Modal } from 'antd'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { rubricRefinementSelectors } from '../../../../../../../store/selectors/rubricRefinement.selectors'
import { useStartRefinementMutation, useAbortRefinementMutation } from '../../../../../../../store/apis/rubric-refinement.api'
import { ExclamationCircleOutlined, RetweetOutlined } from '@ant-design/icons'

const StartOverButton = props => {
    const refinementProcess = useSelector(rubricRefinementSelectors.refinementProcess)
    const refinementProgress = useSelector(rubricRefinementSelectors.refinementProgress)
    const [startRefinement] = useStartRefinementMutation()
    const [abortRefinement, { isLoading: isAbortingRefinement }] = useAbortRefinementMutation()

    const { token, layerId: questionId } = useParams()

    const handleStartOver = async () => {
        Modal.confirm({
            title: 'Are you sure you want to start over?',
            icon: <ExclamationCircleOutlined />,
            content: 'This will reset the refinement process and start over from the beginning.',
            okText: 'Start Over',
            okType: 'danger',
            onOk: async () => {
                if (refinementProcess?.id) {
                    try {
                        // First abort the current refinement
                        await abortRefinement({id: refinementProcess.id, token}).unwrap()
                        // Then start a new one
                        await startRefinement({ questionId }).unwrap()
            } catch (error) {
                console.error('Error starting over:', error)
                    }
                }
            }
        })
    }

    const hasReviewedItems = refinementProgress?.itemsReviewed > 0

    return (
        <Button 
            onClick={handleStartOver}
            loading={isAbortingRefinement}
            type="text"
            danger
            {...props}
            icon={<RetweetOutlined />}
            disabled={!hasReviewedItems}
        >
            Start Over
        </Button>
    )
}

export default StartOverButton 